module.exports = __webpack_public_path__ + "static/media/logo.e0c6f53b.svg";